// Note: if we eventually add more than 2 themes, this is inteneded to allow easily switching between the
// light and dark versions of those themes.
import { getOsPreferredTheme } from './getOsPreferredTheme';
/**
 * This should choose the opposite-contrast version of the current theme.
 * Ie:
 * - "dark" -> "light"
 * - "light" -> "dark"
 * - "monokai" -> "monokaiDark" // Not yet implemented, just intended as an example.
 * - etc...
 */
export const toggleLightVsDarkTheme = (themeKey) => {
    switch (themeKey) {
        case 'DARK':
            return 'LIGHT';
        case 'LIGHT':
            return 'DARK';
        // Example in case we ever add more than just the 2 basic themes:
        // case 'monokai':
        //   return 'monokaiDark';
        // case 'monokaiDark':
        //   return 'monokai';
        case 'AUTO':
        /* eslint-ignore-next-line no-fallthrough */
        default: {
            /** User's preference for dark or light in the browser */
            const osDarkModePreferred = getOsPreferredTheme();
            if (osDarkModePreferred) {
                return 'LIGHT';
            }
            else {
                return 'DARK';
            }
        }
    }
};
